import { Routes } from '@angular/router';
import { RedirectComponent } from './redirect/redirect.component';
import { AcceptInvitationComponent } from './accept-invitation/accept-invitation.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { authenticatedGuard } from './core/guards/authenticated.guard';
import { notAuthenticatedGuard } from './core/guards/not-authenticated.guard';
import { NotFoundPageComponent } from './not-found-page/not-found-page.component';
import { AuthComponent } from './auth/auth.component';
import { WorkspaceComponent } from './workspace/workspace.component';

import { routes as authRoutes } from './auth/auth-routes';
import { routes as workspaceRoutes } from './workspace/workspace-routes';
import { WelcomingV2Component } from './welcoming-v2/welcoming-v2.component';

export const routes: Routes = [
  { path: '', component: RedirectComponent },
  {
    path: 'welcoming',
    data: { breadcrumb: 'Welcoming' },
    component: WelcomingV2Component,
    canActivate: [notAuthenticatedGuard]
  },
  {
    path: 'auth',
    data: { breadcrumb: 'Auth' },
    component: AuthComponent,
    canActivate: [notAuthenticatedGuard],
    children: authRoutes
  },
  {
    path: 'workspace',
    data: { breadcrumb: 'Workspace' },
    canActivate: [authenticatedGuard],
    component: WorkspaceComponent,
    children: workspaceRoutes
  },
  {
    path: 'i/:code/:invitation_id/:user_type',
    data: { invitation: 'dashboard' },
    component: AcceptInvitationComponent
  },
  { path: 'reset-password', redirectTo: 'auth/forgot-password' },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: '**', pathMatch: 'full', component: NotFoundPageComponent }
];
